import React, { useState } from "react";
import Other from "./Other";

import EditIcon from "../../../../../../assets/images/incident/btn_edit.svg";
import DeleteIcon from "../../../../../../assets/images/incident/btn_delete.svg";

function OtherForm(props) {
  const [isView, setIsView] = useState(props.isView);
  const {
    changeShowOtherFormBool,
    changeHideOtherFormBool,
    showOtherForm,
  } = props;

  const employeeForm = (values) => {
    props.addForm({
      employee_or_guest: "employee",
      ...values,
    });
  };

  const removeOther = () => {
    let newArr = [];
    props.forms.forEach((form) => {
      if (form.other_no == props.selectedOtherNo) {
        newArr.push({ ...form, status: "delete" });
      } else {
        newArr.push({ ...form });
      }
    });
    props.setForms(newArr);
    props.onChangeIncidetOther(newArr);
    props.changeHideOtherFormBool();
  };

  return (
    <div className="witness_form_container">
      <div className="witness_form" style={{ display: "flex" }}>
        <div className="witness_form_title">Others</div>
        <div
          style={{
            marginLeft: "auto",
            display: "flex",
          }}
        >
          {props.isEdit ? (
            isView ? (
              <div
                className="delete_btn"
                onClick={() => {
                  props.setIsView(false);
                  setIsView(false);
                }}
                // onClick={() => removeWitness(_, index)}
              >
                <img src={EditIcon} />
              </div>
            ) : null
          ) : null}
          {props.selectedDetail ? (
            <div className="delete_btn" onClick={removeOther}>
              <img src={DeleteIcon} />
            </div>
          ) : null}
        </div>
      </div>
      <Other
        employeeForm={employeeForm}
        changeShowOtherFormBool={changeShowOtherFormBool}
        changeHideOtherFormBool={changeHideOtherFormBool}
        showOtherForm={showOtherForm}
        selectedDetail={props.selectedDetail}
        totalForms={props.totalForms}
        previousIncident={props.previousIncident}
        selectedOtherNo={props.selectedOtherNo}
        onListenValueChange={props.onListenValueChange}
        mainSaveButton={props.mainSaveButton}
        incidentStatus={props.incidentStatus}
        setIncidentStatus={props.setIncidentStatus}
        setCheckStatus={props.setCheckStatus}
        perms={props.AuthDetail.perms}
        prevCategory={props.previousIncident.filtered_category}
        customModalForConfirmCancel={props.customModalForConfirmCancel}
        valueChanged={props.valueChanged}
        showNotiPage={props.showNotiPage}
        overViewValues={props.overViewValues}
        AuthDetail={props.AuthDetail}
        newAddedSignature={props.newAddedSignature}
        setNewAddedSignature={props.setNewAddedSignature}
        isView={isView}
        setIsView={setIsView}
        isEdit={props.isEdit}
        setIsEdit={props.setIsEdit}
      />
    </div>
  );
}

export default OtherForm;
